import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Color } from '../../common/style/color'
import { ScrollButton } from '../../common/style/components/ScrollButton'
import { mobile } from '../../common/style/media-queries'
import { HOW_DOES_IT_WORK_SECTION_NAME } from '../how-lalilo-works'

const ArrowIcon: React.FC = () => (
  <ArrowSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 14">
    <path
      fill="none"
      fillRule="evenodd"
      stroke={Color.purple_600}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M22 2L12 12 2 2"
    />
  </ArrowSVG>
)

const bounce = keyframes`
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`

const ArrowSVG = styled.svg`
  animation: ${bounce} 2s infinite;
  cursor: pointer;
  width: 25px;

  @media ${mobile} {
    width: 20px;
  }
`

export const Arrow: React.FC<{
  className?: string
  offset: number
  ariaLabel: string
}> = ({ className, ariaLabel, offset }) => (
  <StyledScrollButton
    ariaLabel={ariaLabel}
    className={className}
    offset={offset}
    targetId={HOW_DOES_IT_WORK_SECTION_NAME}
  >
    <ArrowIcon />
  </StyledScrollButton>
)

const StyledScrollButton = styled(ScrollButton)`
  width: 60px;
  height: 60px;
  padding-top: 5px;
  border-radius: 50%;

  &:focus {
    outline: ${Color.purple_600} solid 2px;
  }
`
